import { render, staticRenderFns } from "./TabVerificaAuto.vue?vue&type=template&id=c4824672&"
import script from "./TabVerificaAuto.vue?vue&type=script&lang=js&"
export * from "./TabVerificaAuto.vue?vue&type=script&lang=js&"
import style0 from "./TabVerificaAuto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabVerificaAuto.vue
// module id = 827
// module chunks = 0